import formatPrice from "@/lib/formatPrice";
import styles from "@/styles/Price.module.scss";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export default function TrialFormatPriceSVOD(_ref) {
  let {
    price,
    ext,
    course
  } = _ref;
  return /*#__PURE__*/_jsxs("span", {
    className: `${styles.price} ${styles.svod} ${styles.trial}`,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.slate,
      children: /*#__PURE__*/_jsxs("span", {
        className: styles.bold,
        children: ["\u3010\u521D\u56DE\u8CFC\u5165\u9650\u5B9A\u3011", course.trialTermText]
      })
    }), /*#__PURE__*/_jsx("br", {
      className: styles.break
    }), course.trialText, "\u671F\u9593\u5F8C\u306F\u6708\u984D", /*#__PURE__*/_jsx("span", {
      className: styles.bold,
      children: formatPrice(price)
    }), "\u5186\uFF08\u7A0E\u8FBC\uFF09", ext]
  });
}